import Vue from 'vue'
import Router from 'vue-router'
import Media from './views/Media'
import TOC from './views/TOC'
import Home from './views/Home'
import StudyCard from './views/StudyCard'
import Assessment from './views/Assessment'
import Notes from './views/Notes'
import Qmm from './views/QMM'
import CPD from './views/CPD'
import store from './store/index'

Vue.use(Router)

let routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/:book',
    name: 'toc',
    component: TOC,
    props: true
  },
  {
    path: '/:book/assessment',
    name: 'assessment',
    component: Assessment,
    props: true
  },
  {
    path: '/:book/media',
    name: 'media',
    component: Media,
    props: true
  },
  {
    path: '/:book/notes',
    name: 'notes',
    component: Notes,
    props: true
  },
  {
    path: '/:book/qmm',
    name: 'qmm',
    component: Qmm,
    props: true
  },
  {
    path: '/:book/study-card',
    name: 'study-card',
    component: StudyCard,
    props: true
  },
  {
    path: '/:book/cpd-content',
    name: 'cpd-content',
    component: CPD,
    props: true
  }
]

const isProofingEnabled = process.env.VUE_APP_IS_PROOFING_ENABLED

if (isProofingEnabled === 'true') {
  const proofingRoutes = routes.map(mapRoute => {
    return {
      path: `/proofing${mapRoute.path}`,
      name: `proof-${mapRoute.name}`,
      component: mapRoute.component,
      props: mapRoute.props
    }
  })
  routes.splice(1, 0, ...proofingRoutes)
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
})

router.beforeEach((to, from, next) => {
  const chapter = store.state.book.chapterHeading
  const toPath = to.path
  const toPaths = toPath.split('/')
  let nextPath = ''

  if (toPath.startsWith('/proofing')) {
    const bookPath = toPaths[2]
    nextPath = `/proofing/${bookPath}`
  } else {
    const bookPath = toPaths[1]
    nextPath = `/${bookPath}`
  }

  if (
    to.name !== 'toc' &&
    to.name !== 'home' &&
    to.name !== 'proof-toc' &&
    chapter === ''
  ) {
    next(nextPath)
  } else {
    store.dispatch('book/INCREMENT_COMPONENT_KEY')
    next()
  }
})

export default router
